<template>
	<div class="study-center-page">
		<nav-bar title="学习中心" id="navbar" style="font-size: 18px;"></nav-bar>

		<section class="study-hero">
			<div class="hero-copy">
				<p class="hero-kicker">学员您好</p>
				<h1>请选择课程类型进入学习</h1>
				<p>预祝您顺利结业，学习记录会按所选培训类型同步归档。</p>
			</div>
			<div class="hero-badge">
				<van-icon name="records" />
				<span>在线学习</span>
			</div>
		</section>

		<section class="course-section">
			<div class="section-heading">
				<div>
					<p>学习入口</p>
					<h2>常用培训课程</h2>
				</div>
				<span>{{ courses.length }} 项</span>
			</div>

			<div class="course-grid">
				<button
					v-for="course in courses"
					:key="course.appNo"
					type="button"
					class="course-card"
					:style="courseStyle(course)"
					@click="openCourse(course)"
				>
					<span class="course-icon">
						<van-icon :name="course.icon" />
					</span>
					<span class="course-name">{{ course.name }}</span>
					<span class="course-desc">{{ course.desc }}</span>
				</button>
			</div>
		</section>

		<section class="course-section special-section">
			<div class="section-heading">
				<div>
					<p>地区专场</p>
					<h2>驾培专属入口</h2>
				</div>
			</div>

			<div class="special-list">
				<button
					v-for="special in specials"
					:key="special.organizationNo"
					type="button"
					class="special-card"
					@click="openCourse(special)"
				>
					<span class="special-icon">
						<van-icon name="location-o" />
					</span>
					<span>
						<strong>{{ special.name }}</strong>
						<em>{{ special.desc }}</em>
					</span>
					<van-icon name="arrow" />
				</button>
			</div>
		</section>

		<section class="help-card">
			<div class="help-title">
				<span>
					<van-icon name="warning-o" />
				</span>
				<div>
					<h2>登录遇到问题？</h2>
					<p>如果登录过程中操作失误造成无法学习，可以初始化登录信息后重新登录。</p>
				</div>
			</div>
			<van-button class="reset-button" round block color="#ff7f1f" @click="handleInit">
				清除登录信息
			</van-button>
		</section>
	</div>
</template>

<script>
	import {NavBar, Toast} from "vant";

	const appLoginBase = "/index.html#/login";

	export default {
        name: "study-center",
		components: { NavBar },
		data() {
			return {
				courses: [
					{ appNo: "APP01", name: "驾培理论培训", desc: "C1/C2/C3 学时课程", icon: "logistics", color: "#ff7f1f", tint: "#fff2e6", url: `${appLoginBase}?appNo=APP01` },
					{ appNo: "APP02", name: "从业继续教育", desc: "道路运输继续教育", icon: "todo-list-o", color: "#26aaa3", tint: "#e7f8f5", url: `${appLoginBase}?appNo=APP02` },
					{ appNo: "APP03", name: "企业安全培训", desc: "企业安全生产课程", icon: "cluster-o", color: "#2f7df6", tint: "#eaf2ff", url: `${appLoginBase}?appNo=APP03` },
					{ appNo: "APP04", name: "岗前教育培训", desc: "岗前学习与考核", icon: "aim", color: "#ff6f72", tint: "#fff0f1", url: `${appLoginBase}?appNo=APP04` },
					{ appNo: "APP05", name: "诚信考核", desc: "诚信教育专项", icon: "star-o", color: "#f0a22e", tint: "#fff7e7", url: `${appLoginBase}?appNo=APP05` },
					{ appNo: "APP06", name: "两类人员培训", desc: "两类人员安全课程", icon: "shield-o", color: "#58ba45", tint: "#eef9ea", url: `${appLoginBase}?appNo=APP06` },
					{ appNo: "APP09", name: "从业资格证", desc: "资格证学习与考试", icon: "certificate", color: "#7565db", tint: "#f1efff", url: `${appLoginBase}?appNo=APP09` },
					{ appNo: "APP10", name: "公务用车安全培训", desc: "公务用车安全教育", icon: "logistics", color: "#4d94df", tint: "#edf6ff", url: `${appLoginBase}?appNo=APP10` }
				],
				specials: [
					{ appNo: "APP01", organizationNo: "H94L6664J486", name: "黑龙江驾培", desc: "黑龙江地区驾培学员入口", url: "/#/hljJpLogin?appNo=APP01&organizationNo=H94L6664J486" },
					{ appNo: "APP01", organizationNo: "C25TH01SDU6", name: "聊城驾培", desc: "聊城地区驾培学员入口", url: "/#/hljJpLogin?appNo=APP01&organizationNo=C25TH01SDU6" }
				]
			}
		},
		methods: {
			courseStyle(course) {
				return {
					"--course-color": course.color,
					"--course-tint": course.tint
				}
			},
			openCourse(course) {
				sessionStorage.setItem("appno", course.appNo);
				window.location.href = course.url;
			},
			handleInit() {
				sessionStorage.clear();
				localStorage.clear();
				let keys = document.cookie.match(/[^ =;]+(?=)/g);
				if(keys) {
					for(let i = keys.length; i--;)
						document.cookie = keys[i] + '=0;domain=h5.xunmeizaixian.com;expires=' + new Date(0).toUTCString() + ';path=/';
				}
				Toast.success("初始化完毕，请您重新以正确的方式登录。");
			}
		}
	}
</script>

<style scoped>
	.study-center-page {
		width: 100%;
		max-width: 100vw;
		min-height: 100vh;
		padding: 0 0.24rem 0.42rem;
		background:
			linear-gradient(180deg, #fff7ed 0, #f7faf9 3.9rem, #f5f6f8 100%);
		color: #263238;
		box-sizing: border-box;
		overflow-x: hidden;
	}

	#navbar {
		margin: 0 -0.24rem;
		background-color: #fff;
	}

	#navbar /deep/ .van-nav-bar__title {
		font-size: 18px;
		font-weight: 700;
		color: #1f2726 !important;
	}

	#navbar /deep/ .van-icon,
	#navbar /deep/ .van-nav-bar__text {
		color: #1f2726 !important;
	}

	.study-hero {
		position: relative;
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
		min-height: 2.36rem;
		margin: 0 -0.24rem;
		padding: 0.4rem 0.36rem 0.52rem;
		overflow: hidden;
		background:
			radial-gradient(circle at 86% 16%, rgba(255, 255, 255, 0.42) 0, rgba(255, 255, 255, 0) 1.2rem),
			linear-gradient(135deg, #ff7b1a 0%, #ff9a36 62%, #ffc36b 100%);
		box-sizing: border-box;
		color: #fff;
	}

	.study-hero::after {
		content: "";
		position: absolute;
		right: -0.44rem;
		bottom: -0.48rem;
		width: 2.24rem;
		height: 1.38rem;
		border-radius: 1.1rem 0 0 0;
		background: rgba(255, 255, 255, 0.2);
		transform: rotate(-8deg);
	}

	.hero-copy {
		position: relative;
		z-index: 1;
		max-width: 4.7rem;
	}

	.hero-kicker {
		margin: 0 0 0.12rem;
		font-size: 0.24rem;
		font-weight: 700;
		opacity: 0.9;
	}

	.hero-copy h1 {
		margin: 0;
		font-size: 0.42rem;
		line-height: 1.25;
		font-weight: 800;
		letter-spacing: 0;
	}

	.hero-copy p:last-child {
		margin: 0.18rem 0 0;
		font-size: 0.24rem;
		line-height: 1.55;
		opacity: 0.94;
	}

	.hero-badge {
		position: relative;
		z-index: 1;
		display: inline-flex;
		align-items: center;
		gap: 0.08rem;
		padding: 0.12rem 0.16rem;
		border-radius: 999px;
		background: rgba(255, 255, 255, 0.2);
		font-size: 0.22rem;
		font-weight: 700;
		white-space: nowrap;
	}

	.course-section {
		margin-top: 0.24rem;
	}

	.section-heading {
		display: flex;
		align-items: flex-end;
		justify-content: space-between;
		margin-bottom: 0.18rem;
	}

	.section-heading p {
		margin: 0 0 0.04rem;
		font-size: 0.22rem;
		font-weight: 700;
		color: #ff7f1f;
	}

	.section-heading h2 {
		margin: 0;
		font-size: 0.32rem;
		line-height: 1.25;
		font-weight: 800;
		color: #263238;
	}

	.section-heading > span {
		font-size: 0.22rem;
		font-weight: 700;
		color: #8a9592;
	}

	.course-grid {
		display: grid;
		grid-template-columns: repeat(2, minmax(0, 1fr));
		gap: 0.18rem;
	}

	.course-card {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		min-height: 2.28rem;
		padding: 0.24rem 0.22rem;
		border: 1px solid rgba(47, 59, 57, 0.06);
		border-radius: 0.24rem;
		background: #fff;
		box-shadow: 0 0.12rem 0.3rem rgba(24, 39, 75, 0.06);
		text-align: left;
		box-sizing: border-box;
	}

	.course-card:active,
	.special-card:active {
		transform: scale(0.985);
	}

	.course-icon {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		width: 0.78rem;
		height: 0.78rem;
		margin-bottom: 0.2rem;
		border-radius: 50%;
		background: var(--course-tint);
		color: var(--course-color);
		font-size: 0.42rem;
	}

	.course-name {
		font-size: 0.3rem;
		line-height: 1.25;
		font-weight: 800;
		color: var(--course-color);
	}

	.course-desc {
		margin-top: 0.08rem;
		font-size: 0.22rem;
		line-height: 1.35;
		color: #7a8582;
	}

	.special-section {
		margin-top: 0.34rem;
	}

	.special-list {
		display: grid;
		gap: 0.16rem;
	}

	.special-card {
		display: grid;
		grid-template-columns: auto 1fr auto;
		align-items: center;
		gap: 0.18rem;
		width: 100%;
		padding: 0.2rem 0.22rem;
		border: 1px solid rgba(255, 127, 31, 0.14);
		border-radius: 0.22rem;
		background: #fff;
		box-shadow: 0 0.08rem 0.24rem rgba(255, 127, 31, 0.08);
		text-align: left;
		box-sizing: border-box;
		color: #8a9592;
	}

	.special-icon {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		width: 0.64rem;
		height: 0.64rem;
		border-radius: 50%;
		background: #fff2e6;
		color: #ff7f1f;
		font-size: 0.34rem;
	}

	.special-card strong,
	.special-card em {
		display: block;
		font-style: normal;
	}

	.special-card strong {
		font-size: 0.28rem;
		line-height: 1.3;
		font-weight: 800;
		color: #263238;
	}

	.special-card em {
		margin-top: 0.04rem;
		font-size: 0.22rem;
		line-height: 1.35;
		color: #8a9592;
	}

	.help-card {
		margin-top: 0.28rem;
		padding: 0.24rem;
		border: 1px solid rgba(255, 111, 114, 0.14);
		border-radius: 0.24rem;
		background: #fff;
		box-shadow: 0 0.12rem 0.32rem rgba(24, 39, 75, 0.06);
	}

	.help-title {
		display: grid;
		grid-template-columns: auto 1fr;
		gap: 0.16rem;
		align-items: flex-start;
	}

	.help-title > span {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		width: 0.58rem;
		height: 0.58rem;
		border-radius: 50%;
		background: #fff0f1;
		color: #ff6f72;
		font-size: 0.32rem;
	}

	.help-title h2 {
		margin: 0;
		font-size: 0.3rem;
		line-height: 1.35;
		font-weight: 800;
		color: #263238;
	}

	.help-title p {
		margin: 0.08rem 0 0;
		font-size: 0.24rem;
		line-height: 1.55;
		color: #6f7a77;
	}

	.reset-button {
		margin-top: 0.22rem;
		height: 0.88rem;
		font-size: 0.28rem;
		font-weight: 800;
	}

	@media screen and (min-width: 750px) {
		.study-center-page {
			max-width: 750px;
			margin: 0 auto;
		}
	}
</style>
